module.exports = __webpack_public_path__ + "img/zj.20dfe2d7.png";